import {Icon} from '@atoms';
import {ModalCellItem, ModalCellItemIcon} from '@molecules';
import {FlexCol} from '@quarks';
import {pxToRem} from '@utils';
import {ReactNode} from 'react';
import {ModalCellItemIconProps} from 'src/components/molecules/ModalCellItemIcon/types';
import {StyledText} from './styles';

// This is now purely a display component; the parent handles what it does
export const BookingLocationCellItem_timeslots = ({
  icon,
  isDisabled,
  isActive,
  title,
  subTitle,
  onClick,
  canNavigate = true,
}: {
  icon: ModalCellItemIconProps['icon'];
  isDisabled: boolean;
  isActive: boolean;
  title: string;
  subTitle?: ReactNode;
  onClick: () => void;
  canNavigate?: boolean;
}) => {
  return (
    <ModalCellItem
      alignItems="flex-start"
      onClick={() => {
        if (isDisabled) return;
        onClick();
      }}
      disabled={isDisabled}
      left={
        <ModalCellItemIcon
          icon={icon}
          disabled={isDisabled}
          selected={isActive}
        />
      }
      middle={
        <FlexCol
          paddingTop={8}
          gap={8}>
          <StyledText
            fontWeight="bold"
            data-testid="booking-location_name"
            $disabled={isDisabled}>
            {title}
          </StyledText>
          <StyledText $disabled={isDisabled}>{subTitle}</StyledText>
        </FlexCol>
      }
      right={
        !isDisabled &&
        canNavigate && (
          <Icon
            icon="caretRight"
            size={pxToRem(24)}
          />
        )
      }
    />
  );
};
